import React from "react";
// mui
import { Box, Stack, Tooltip, Typography } from "@mui/material";
// icons
import { MdAccessTime } from "react-icons/md";
import { HiOutlineUser } from "react-icons/hi2";
import { MdOutlineAlternateEmail } from "react-icons/md";
// moment
import moment from "moment";
const NotificationCard = ({ notificationDetails }) => {
    const { title, body, created_at, topic, sender } = notificationDetails;
    const { name, email } = sender;
    return (
        <Stack
            sx={{
                boxShadow: 1,
                borderRadius: 1,
                p: 2,
                border: "1px solid #f1f1f1",
                minWidth: { xs: "290px", sm: "350px" },
                flex: 1,
            }}
        >
            <Box>
                <Typography variant="h6">{title}</Typography>
                <Box
                    width="100%"
                    display="flex"
                    justifyContent="flex-start"
                    alignItems="center"
                    gap="10px"
                >
                    <Tooltip title="تارخ انشاء الاشعار" arrow>
                        <Typography
                            sx={{
                                fontSize: "12px",
                                color: "#333",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "5px",
                                marginBottom: 1,
                            }}
                        >
                            <MdAccessTime />{" "}
                            {moment(created_at).format("YYYY/MM/DD HH:mm")}
                        </Typography>
                    </Tooltip>
                    <Tooltip title="اسم مُرسِل الاشعار" arrow>
                        <Typography
                            sx={{
                                fontSize: "12px",
                                color: "#333",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "5px",
                                marginBottom: 1,
                            }}
                        >
                            <HiOutlineUser /> {name}
                        </Typography>
                    </Tooltip>
                    <Tooltip title="بريد مُرسِل الاشعار" arrow>
                        <Typography
                            sx={{
                                fontSize: "12px",
                                color: "#333",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "5px",
                                marginBottom: 1,
                            }}
                        >
                            <MdOutlineAlternateEmail /> {email}
                        </Typography>
                    </Tooltip>
                </Box>
                <Typography variant="body1">{body}</Typography>
            </Box>
        </Stack>
    );
};

export default NotificationCard;
